import { Modal, Text, TextContainer } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

export const CannotRemovePlatformModal = ({ isOpen, closeModal }: { isOpen: boolean; closeModal: () => void }) => {
  const intl = useIntl();

  return (
    <Modal
      title={intl.formatMessage({
        id: "funding-application: cannot remove modal title",
        defaultMessage: "Sorry, removing this platform is not possible",
      })}
      primaryAction={{
        onAction: closeModal,
        content: intl.formatMessage({
          id: "funding-application: cannot remove modal okay",
          defaultMessage: "Okay",
        }),
      }}
      isOpen={isOpen}
      onClose={closeModal}
    >
      <TextContainer>
        <Text>
          {intl.formatMessage({
            id: "funding-application: cannot remove - need revenue platform",
            defaultMessage:
              "You must connect a platform we support that will give us visibility into your sales performance. This can either be a supported eCommerce platform, Google Analytics or Stripe.",
          })}
        </Text>
        <Text>
          {intl.formatMessage({
            id: "funding-application: cannot remove - chat to us message",
            defaultMessage:
              "If you need help, chat to us using the link on this page or reach out to your Wayflyer representative directly if you have one.",
          })}
        </Text>
      </TextContainer>
    </Modal>
  );
};
